import { LazyPage, VercelInstallPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The popup Vercel opens as the integration's redirect URL. Unauthenticated:
// the page itself decides between login and connect.
function VercelInstallRoute() {
  return (
    <LazyPage>
      <VercelInstallPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/vercel/install')({
  component: VercelInstallRoute,
});
